// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__qcw1L","navbarScrollCustom":"carroFicha_navbarScrollCustom__9eGPf","rectangle":"carroFicha_rectangle__KuLad"};